"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDotProperty = exports.getValueByPath = exports.concatStringsWithWhitespace = exports.dataURLtoFile = exports.toBase64 = exports.fnChain = exports.maxDurationGranule = exports.sliceDuration = exports.formatDurationToObject = exports.getTimeSymbolTitle = exports.formatDuration = exports.formatTime = exports.formatHumanDateShort = exports.formatHumanDateTime = exports.formatHumanDate = exports.getTimeStampInSec = exports.EMPTY_FUNCTION = exports.caseInsensitiveCompare = exports.formatAddress = exports.setTimeExtremum = exports.getSafePropertyName = void 0;
const moment_1 = __importDefault(require("moment"));
const getSafePropertyName = (name) => Array.from(name.match(/([\w])/g) || [])
    .join("")
    .replace(/^\w/, (char) => char.toLowerCase());
exports.getSafePropertyName = getSafePropertyName;
const setTimeExtremum = (date, isMax = true) => {
    const params = [date.getDate()];
    if (isMax) {
        params.push(23, 59, 59, 999);
    }
    else {
        params.push(0);
    }
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), ...params));
};
exports.setTimeExtremum = setTimeExtremum;
const formatAddress = (address = "") => address.slice(0, 4) + "..." + address.slice(address.length - 4, address.length);
exports.formatAddress = formatAddress;
const caseInsensitiveCompare = (left = "", right = "") => (left && right && left.toLocaleLowerCase() === right.toLocaleLowerCase()) || left === right;
exports.caseInsensitiveCompare = caseInsensitiveCompare;
// tslint:disable-next-line: no-empty
const EMPTY_FUNCTION = () => { };
exports.EMPTY_FUNCTION = EMPTY_FUNCTION;
const getTimeStampInSec = (date) => Math.floor((date ? new Date(date) : new Date()).getTime() / 1000);
exports.getTimeStampInSec = getTimeStampInSec;
const formatHumanDate = (date) => (0, moment_1.default)(date).format("DD MMM, yyyy");
exports.formatHumanDate = formatHumanDate;
const formatHumanDateTime = (date) => (0, moment_1.default)(date).format("MMMM DD, yyyy [at] hh:mm:ss a");
exports.formatHumanDateTime = formatHumanDateTime;
const formatHumanDateShort = (date) => (0, moment_1.default)(date).format("MMM DD");
exports.formatHumanDateShort = formatHumanDateShort;
const formatTime = (value) => `00${value}`.slice(-2);
exports.formatTime = formatTime;
const formatDuration = (durationInSec) => {
    return (0, exports.sliceDuration)(durationInSec).filter(Boolean).join(" : ");
};
exports.formatDuration = formatDuration;
const TIME_SYMBOL_DICTIONARY = {
    Y: "year",
    M: "month",
    D: "day",
    h: "hour",
    m: "min",
    s: "sec",
};
const getTimeSymbolTitle = (value, symbol) => {
    return `${TIME_SYMBOL_DICTIONARY[symbol]}${value > 1 ? "s" : ""}`;
};
exports.getTimeSymbolTitle = getTimeSymbolTitle;
const formatDurationToObject = (durationInSec) => {
    const duration = moment_1.default.duration(durationInSec, "seconds");
    return {
        inYearsLeft: duration.asYears(),
        yearsLeft: duration.years(),
        inMonthLeft: duration.asMonths(),
        monthLeft: duration.months(),
        inDaysLeft: duration.asDays(),
        daysLeft: duration.days(),
        inHoursLeft: duration.asHours(),
        hoursLeft: duration.hours(),
        inMinutesLeft: duration.asMinutes(),
        minutesLeft: duration.minutes(),
        inSecondsLeft: duration.asSeconds(),
        secondsLeft: duration.seconds(),
    };
};
exports.formatDurationToObject = formatDurationToObject;
const sliceDuration = (durationInSec, [yearLabel = "Y", monthLabel = "M", dayLabel = "D", hourLabel = "h", minLabel = "m", secLabel = "s"] = []) => {
    const duration = moment_1.default.duration(durationInSec, "seconds");
    const yearsLeft = duration.years();
    const monthLeft = duration.months();
    const daysLeft = duration.days();
    const hoursLeft = duration.hours();
    const minutesLeft = duration.minutes();
    const secondsLeft = duration.seconds();
    return [
        yearsLeft ? yearsLeft + yearLabel : "",
        monthLeft ? monthLeft + monthLabel : "",
        daysLeft ? daysLeft + dayLabel : "",
        hoursLeft ? (0, exports.formatTime)(hoursLeft) + hourLabel : "",
        minutesLeft ? (0, exports.formatTime)(minutesLeft) + minLabel : "",
        secondsLeft ? (0, exports.formatTime)(secondsLeft) + secLabel : "",
    ].filter(Boolean);
};
exports.sliceDuration = sliceDuration;
const maxDurationGranule = (durationInSec) => {
    const maxGranule = durationInSec > 0 ? (0, exports.sliceDuration)(durationInSec)[0] : "0s";
    return {
        symbol: maxGranule.slice(-1),
        value: +maxGranule.slice(0, -1),
        title: (0, exports.getTimeSymbolTitle)(+maxGranule.slice(0, -1), maxGranule.slice(-1)),
    };
};
exports.maxDurationGranule = maxDurationGranule;
const fnChain = (...args) => () => __awaiter(void 0, void 0, void 0, function* () {
    let result = undefined;
    for (const fn of args) {
        if (typeof fn === "function") {
            const fnResult = fn(result);
            if (fnResult && "then" in fnResult) {
                result = yield fnResult;
            }
            result = fnResult;
        }
    }
    return result;
});
exports.fnChain = fnChain;
const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => { var _a; return resolve(((_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString()) || ""); };
    reader.onerror = (error) => reject(error);
});
exports.toBase64 = toBase64;
const dataURLtoFile = (dataUrl, filename) => {
    var _a;
    var [type, data] = dataUrl.split(","), mime = (_a = type.match(/:(.*?);/)) === null || _a === void 0 ? void 0 : _a[1], byteString = atob(data), length = byteString.length, buffer = new Uint8Array(length);
    while (length--) {
        buffer[length] = byteString.charCodeAt(length);
    }
    return new File([buffer], filename, { type: mime });
};
exports.dataURLtoFile = dataURLtoFile;
const concatStringsWithWhitespace = (...args) => args.filter(Boolean).join(" ");
exports.concatStringsWithWhitespace = concatStringsWithWhitespace;
const getValueByPath = (obj, path) => path.split(".").reduce((obj, part) => (obj === null || obj === void 0 ? void 0 : obj[part]) || undefined, obj);
exports.getValueByPath = getValueByPath;
const setDotProperty = (obj, propPath, value) => {
    const [rootPathSection, ...other] = propPath.split(".");
    const pathToValue = other.join(".");
    if (!obj[rootPathSection]) {
        obj[rootPathSection] = {};
    }
    if (pathToValue) {
        return (0, exports.setDotProperty)(obj[rootPathSection], pathToValue, value);
    }
    else {
        obj[rootPathSection] = value;
        return obj;
    }
};
exports.setDotProperty = setDotProperty;
